import { useServices } from "@/services-context";
import { cssAliases } from "@/style/css-aliases";
import { PropsWithChildren } from "preact/compat";
import { useLayoutEffect, useMemo } from "preact/hooks";
import { CUSTOMER_CHANNEL_LISTENER_NAME } from "@/services/customer-channel.ts";

export const ThemeProvider = ({ children }: PropsWithChildren<{}>) => {
    const services = useServices([CUSTOMER_CHANNEL_LISTENER_NAME]);
    const aliases = useMemo(() => cssAliases(), []);

    const theme = services.customerChannel.colorScheme ?? "default";

    useLayoutEffect(() => {
        document.body.setAttribute('data-theme', theme);

        return () => {
            document.body.removeAttribute('data-theme');
        };
    }, [theme]);

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: aliases }} />
            {children}
        </>
    );
}